import PropTypes from 'prop-types';
import React, { memo } from 'react';

import DropDown, { DropDownElement } from '../../helpers/DropDown';

import style from './style.module.css';

/**
 * Approval page toolbar actions menu.
 *
 * @param props {Object}.
 * @param props.disableSetNA {Boolean} If set to true, will disable set next action button.
 * @param props.disableChangeStatus {Boolean} If set to true, will disable change status popup.
 * @param {boolean} props.isGenerateButtonDisabled Whether generate online approval list is disabled or not.
 * @param props.onRunWindwardReport {Function} Open Windward modal window.
 * @param props.generateOnlineApprovalList {Function} Generate Online Approval List modal window.
 * @param props.onSetAction {Function} To open set action popup.
 * @param props.onChangeStatus {Function} To open change status popup.
 * @param props.onExport {Function} To explore associate list.
 * @param {boolean} props.isNoApproval No approval list selected state.
 * @class
 */
const ButtonsComponent = ({
  disableSetNA = false,
  disableChangeStatus = false,
  isGenerateButtonDisabled,
  onRunWindwardReport,
  generateOnlineApprovalList,
  onSetAction,
  onChangeStatus,
  onExport,
  isNoApproval,
}) => (
  <DropDown
    align="right"
    buttonContent="Actions"
    className="btn-default btn-xs"
    id="approvalActions"
    wrapperClassName={style.toolbar}
  >
    {isNoApproval === false && (
      <DropDownElement disabled={isGenerateButtonDisabled} onClick={generateOnlineApprovalList} type="link">
        Generate Online Approval List
      </DropDownElement>
    )}
    <DropDownElement onClick={onRunWindwardReport} type="link">
      Run Windward Report
    </DropDownElement>
    <DropDownElement disabled={disableSetNA} onClick={onSetAction} type="link">
      Set Next Actions
    </DropDownElement>
    <DropDownElement disabled={disableChangeStatus} onClick={onChangeStatus} type="link">
      Change Statuses
    </DropDownElement>
    <DropDownElement onClick={onExport} type="link">
      Export
    </DropDownElement>
  </DropDown>
);

ButtonsComponent.propTypes = {
  disableChangeStatus: PropTypes.bool,
  disableSetNA: PropTypes.bool,
  generateOnlineApprovalList: PropTypes.func.isRequired,
  isGenerateButtonDisabled: PropTypes.bool,
  isNoApproval: PropTypes.bool.isRequired,
  onChangeStatus: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired,
  onRunWindwardReport: PropTypes.func.isRequired,
  onSetAction: PropTypes.func.isRequired,
};

/** Buttons component. */
export const Buttons = memo(ButtonsComponent);
